"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadExternalBounceInteraction = void 0;
const Bouncer_1 = require("./Bouncer");
function loadExternalBounceInteraction(tsParticles) {
    tsParticles.addInteractor("externalBounce", (container) => new Bouncer_1.Bouncer(container));
}
exports.loadExternalBounceInteraction = loadExternalBounceInteraction;
